<script>
    import { createEventDispatcher } from "svelte";
    import SlideshowItem from "../../common/SlideshowItem.svelte";
    import { _ } from "svelte-i18n";

    export let storeItem;
    export let flipped;

    const dispatch = createEventDispatcher();
</script>

<SlideshowItem
    {flipped}
    on:click={() => (window.location.href = storeItem.link)}
    titleImage={storeItem.image}
>
    <div slot="content">
        <div class="text-l type">{$_("recent")}</div>
        <div class="headline-s slogan">{storeItem.title}</div>
        <div
            style="display: flex; justify-content: space-between"
            class="text-l slogan"
        >
            <div>{storeItem.category}</div>
            <div>CHF {parseInt(storeItem.price)?.toFixed(2)}</div>
        </div>
    </div>
</SlideshowItem>

<style>
    .type {
        font-size: 16px;
        text-transform: none;
    }

    .slogan {
        margin-top: 4px;
    }
</style>
